import React from 'react';
import { StyledErrorBox, ErrorIcon } from './errorBox.style';
import { Grid } from '@mui/material';
import HyperLink from 'component/commonComponents/hyperLink/hyperLink';
import Typography from 'component/commonComponents/Typography';

export interface IErrorProps {
  imageSrc?: string;
  title: string;
  message: string;
  onGoHome: () => void;
  locale: {
    goHome: string;
  };
};

const ErrorBox = (props: IErrorProps) => {
  const { imageSrc, title, message, onGoHome, locale } = props;

  return (
    <>
      <StyledErrorBox>
        <Grid container spacing={1}>
          <Grid item xs={12} container justifyContent="center">
            {!!imageSrc ? (
              <img src={imageSrc} alt="error_image" className="error_image" title="Error Image"/>
            ) : (
              <ErrorIcon />
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography kind="h4" className="title" textAlign="center">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography kind="body1" className="message" textAlign="center">
              {message}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <HyperLink
              kind="body2"
              label={locale.goHome}
              onClick={onGoHome}
              hasAnimation
              align='center'
              showArrow
            />
          </Grid>
        </Grid>
      </StyledErrorBox>
    </>
  )
};

export const defaultProps: IErrorProps = {
  imageSrc: "",
  title: 'Something went wrong',
  message: 'Please try again later or go back to home page',
  onGoHome: () => window.location.href = '/',
  locale: {
    goHome: 'Go to home page'
  }
};

ErrorBox.defaultProps = defaultProps;

export default ErrorBox;